module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "container-fluid login"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-4 col-10 col-sm-8 mx-auto login-form"
  }, [_c('router-link', {
    staticClass: "content-logo-principal",
    attrs: {
      "to": "/"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "center",
      "align-items": "center"
    }
  }, [_c('h1', {
    staticClass: "logo-name style-scope page-auth-login"
  }, [_c('a', {
    attrs: {
      "href": "https://royalpag.com/"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "src": _vm.img
    }
  })])])])]), _vm._v(" "), _c('h2', {
    staticClass: "text-center text-default-gray logo_h2",
    staticStyle: {
      "font-size": "16px",
      "font-family": "Roboto"
    }
  }, [_vm._v("\n              Esqueceu (ou trocar) a senha?\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "text-center text-default-gray",
    staticStyle: {
      "font-size": "14px",
      "font-family": "Roboto",
      "margin-bottom": "0px !important"
    }
  }, [_vm._v("Informe o e-mail cadastrado para redefinir sua senha. A ações adicionais serão enviadas para o endereço informado.")]), _vm._v(" "), _c('div', {
    staticClass: "card-body pt-3"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('form', {
    staticClass: "well",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submit.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.usuario.email),
      expression: "usuario.email"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "email_registrado",
      "type": "text",
      "autocomplete": "username",
      "required": "",
      "autofocus": "",
      "placeholder": "Informe e-mail registrado"
    },
    domProps: {
      "value": (_vm.usuario.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.usuario, "email", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    staticClass: "btn btn-primary btn-block",
    style: (_vm.color),
    attrs: {
      "type": "submit",
      "value": "Recuperar Senha"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('span', {
    staticStyle: {
      "padding-left": "15px"
    }
  }, [_vm._v("Lembrou a senha? "), _c('router-link', {
    attrs: {
      "to": "/auth/login",
      "exact": ""
    }
  }, [_vm._v("Voltar")])], 1)])])])])])])])], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-80088a22","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/forgotPassword/index.vue
// module id = Z2Tf
// module chunks = 36